var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { row: "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "500px" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dense: "", dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [
                    _vm._v(
                      _vm._s(_vm.$t("StationEditStationCategory.editTitleMsg"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c("v-select", {
                    attrs: {
                      dense: "",
                      label: "Select a station category",
                      items: _vm.stationCategoryNames,
                    },
                    model: {
                      value: _vm.stationCategory,
                      callback: function ($$v) {
                        _vm.stationCategory = $$v
                      },
                      expression: "stationCategory",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "success", loading: _vm.loading },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.submit()
                        },
                      },
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [_vm._v("done")]),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("Button.Save")) +
                          "\n        "
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "secondary", outline: "" },
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Close")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }